import { render } from "./BaseSelectInput.vue?vue&type=template&id=c08a2dca"
import script from "./BaseSelectInput.vue?vue&type=script&lang=js"
export * from "./BaseSelectInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/filip/coding/shean/reklamace/reklamace-fe-slovakova/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__